import { useMemo } from "react";

import { useTableSelection } from "./useTableSelection";

import { LayerInfo } from "../../interfaces/resourceInfo";

export const useTableSelectionCondition = (layer?: LayerInfo) => {
  const [tableSelection] = useTableSelection();
  const isModeAll = useMemo(() => tableSelection?.[layer?.name]?.mode === "all", [layer?.name, tableSelection]);
  const processedRows = useMemo(
    () => tableSelection?.[layer?.name]?.processedRows ?? [],
    [layer?.name, tableSelection],
  );

  return useMemo(
    () =>
      processedRows.length === 0 || !layer
        ? ""
        : isModeAll
        ? `!include(${layer.layerDefinition?.idAttribute}, [${processedRows.map(value => value).join(",")}])`
        : `include(${layer.layerDefinition?.idAttribute}, [${processedRows.map(value => value).join(",")}])`,
    [isModeAll, layer, processedRows],
  );
};
